var PrimaryPlanFactory = function ($resource, $window) {
    var isLocal = $window.location.hostname === "localhost";
    var useMocks = $window.location.hash.split("?")[1] === "useMocks=true";
    var baseUrl = isLocal && useMocks ? $window.location.origin : __baseApiUrl__;
    var primaryPlanApi =
        isLocal && useMocks
            ? "/participant/accounts/assets/data/get-plan-mocks.json"
            : "/participant-web-services/rest/accounts/primaryPlan";

    return $resource(
        baseUrl + primaryPlanApi,
        {},
        {
            query: {
                method: "GET",
                isArray: false
            }
        }
    );
};

PrimaryPlanFactory.$inject = ["$resource", "$window"];
export default PrimaryPlanFactory;
